// extracted by mini-css-extract-plugin
module.exports = {"tabBlock":"tabs_tabBlock__yM6YV","shareTab":"tabs_shareTab__Kk0SI","tabItem":"tabs_tabItem__zgoRC","tabAnchor":"tabs_tabAnchor__I1tsh"};